import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { finalize, Subject, takeUntil } from 'rxjs';
import saveAs from 'file-saver';
import { ReportesService } from '../../shared/services/reportes.service';
import { Usuario } from '../../shared/models';
import { PerfilStore } from '../../shared/store/perfil.store';
import { Router } from '@angular/router';

@Component({
  selector: 'app-historico',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzSelectModule,
    NzButtonModule,
    NzIconModule
  ],
  templateUrl: './historico.component.html',
  styleUrl: './historico.component.scss'
})
export class HistoricoComponent {
  
  anioSeleccionado: number | null = null;
  anios: number[] = [];
  generarExcel: boolean = false;
  user: Usuario | null = {};
  $onDestroy : Subject<void> = new Subject<void>();
  constructor(private messageService: NzMessageService, private reportesService: ReportesService, private cdr: ChangeDetectorRef, private sessionStore: PerfilStore, private router: Router) {
  }

  ngOnInit(): void {
    this.generarAnios();
    this.getUser();
  }

  getUser() {
      this.sessionStore.getPerfil()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((user:Usuario | null) => {
        this.user = user;
        if(!this.user?.esAdmin && !this.user?.esRRHH){
          this.$onDestroy.next();
          this.$onDestroy.complete();
          this.sessionStore.clearPerfil();
          this.router.navigate(['/']);
        }
      });
  }

  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

  private generarAnios(): void {
    const anioActual = new Date().getFullYear();
    for (let i = 1; i <= 5; i++) {
      this.anios.push(anioActual - i);
    }
  }

  onAnioSeleccionado(anio: number): void {
    this.anioSeleccionado = anio;
  }

  descargarHistorico(): void {
    if (this.anioSeleccionado) {
      this.DescargarExcelHistorico(this.anioSeleccionado);
    }
    else {
      this.messageService.warning('Por favor, seleccione un año para descargar el histórico.');
    }
  }

  DescargarExcelHistorico(anio: number): void {
      this.generarExcel = true;
      this.reportesService.generarExcelBeneficioNoEjecutado( anio ).pipe(
        finalize(
          ()=>{
            this.generarExcel = false;
            this.cdr.detectChanges();
          }
        )
        )
        .subscribe({
          next: (res: any) => {
            try {
              if (res) {
                let blob: Blob;
                if (res instanceof Blob) {
                  blob = res;
                } else {
                  blob = new Blob([res], { 
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                  });
                }
                const nombreArchivo = `${"Reporte Resumen de Gastos Medicos Menores "}_${anio}.xlsx`;            
                saveAs(blob, nombreArchivo);
              } else {
                console.error('La respuesta del servidor está vacía');
              }
            } catch (error) {
              console.error('Error al procesar la descarga del Excel:', error);
            }
          },
          error: (error:any) => {
            console.error('Error al generar Excel:', error);
          }
        });
      }
}
